// components/RestaurantPopularItems/RestaurantPopularItems.jsx
//
// A restaurant-page showcase for its own staff-curated popular items
// (item.popular - the same flag that drives the "Popular" tab under Our
// Menu), separate from the homepage's "Popular Right Now" section, which
// ranks across every restaurant by real order history instead. No fetch
// of its own - reuses the items Menu.jsx already loaded for this
// restaurant. Renders nothing if this restaurant has no popular items,
// same as the "Popular" tab only appearing when there's one.
import React, { useState } from "react";
// Reuses the homepage Popular Items section's styling for visual
// consistency, not its data-fetching logic.
import "../PopularItems/popular-items.css";
import SelectedMenuItem from "../SelectedMenuItem/SelectedMenuItem";

const RestaurantPopularItems = ({ items, restaurant }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const popularItems = items.filter((item) => item.popular && item.availability);

  if (popularItems.length === 0) return null;

  return (
    <section className="popular-items">
      <div className="popular-items-container">
        <span className="eyebrow">Staff Picks</span>
        <h2 className="popular-items-title">
          Popular at {restaurant?.name || "This Restaurant"}
        </h2>

        <div className="popular-items-content">
          {popularItems.map((item) => {
            const price = item.basePrice;
            const category = item.categoryPricing[0].category;
            return (
              <div key={item._id} className="popular-item">
                <img
                  src={item.imageUrl[0]}
                  alt={item.title}
                  className="popular-item-img"
                />
                <h3 className="popular-item-title">{item.title}</h3>
                <p className="popular-item-category">
                  {category.replace(/_/g, " ").toUpperCase()}
                </p>
                <div className="popular-item-price-order">
                  <span className="popular-item-price">৳{price}</span>
                  <button
                    className="popular-item-order-btn btn btn-primary"
                    onClick={() =>
                      setSelectedItem({ ...item, selectedCategory: category, restaurant })
                    }
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {selectedItem && (
        <SelectedMenuItem
          menuItem={selectedItem}
          closeModal={() => setSelectedItem(null)}
        />
      )}
    </section>
  );
};

export default RestaurantPopularItems;
